/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ProbeURLForm,
  ProbeURLForm$Outbound,
  ProbeURLForm$outboundSchema,
} from "../components/probeurlform.js";

export type ProbeRemoteMcpURLSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ProbeRemoteMcpURLSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ProbeRemoteMcpURLSecurity = {
  option1?: ProbeRemoteMcpURLSecurityOption1 | undefined;
  option2?: ProbeRemoteMcpURLSecurityOption2 | undefined;
};

export type ProbeRemoteMcpURLRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  probeURLForm: ProbeURLForm;
};

/** @internal */
export type ProbeRemoteMcpURLSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ProbeRemoteMcpURLSecurityOption1$outboundSchema: z.ZodMiniType<
  ProbeRemoteMcpURLSecurityOption1$Outbound,
  ProbeRemoteMcpURLSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function probeRemoteMcpURLSecurityOption1ToJSON(
  probeRemoteMcpURLSecurityOption1: ProbeRemoteMcpURLSecurityOption1,
): string {
  return JSON.stringify(
    ProbeRemoteMcpURLSecurityOption1$outboundSchema.parse(
      probeRemoteMcpURLSecurityOption1,
    ),
  );
}

/** @internal */
export type ProbeRemoteMcpURLSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ProbeRemoteMcpURLSecurityOption2$outboundSchema: z.ZodMiniType<
  ProbeRemoteMcpURLSecurityOption2$Outbound,
  ProbeRemoteMcpURLSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function probeRemoteMcpURLSecurityOption2ToJSON(
  probeRemoteMcpURLSecurityOption2: ProbeRemoteMcpURLSecurityOption2,
): string {
  return JSON.stringify(
    ProbeRemoteMcpURLSecurityOption2$outboundSchema.parse(
      probeRemoteMcpURLSecurityOption2,
    ),
  );
}

/** @internal */
export type ProbeRemoteMcpURLSecurity$Outbound = {
  Option1?: ProbeRemoteMcpURLSecurityOption1$Outbound | undefined;
  Option2?: ProbeRemoteMcpURLSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ProbeRemoteMcpURLSecurity$outboundSchema: z.ZodMiniType<
  ProbeRemoteMcpURLSecurity$Outbound,
  ProbeRemoteMcpURLSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ProbeRemoteMcpURLSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ProbeRemoteMcpURLSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function probeRemoteMcpURLSecurityToJSON(
  probeRemoteMcpURLSecurity: ProbeRemoteMcpURLSecurity,
): string {
  return JSON.stringify(
    ProbeRemoteMcpURLSecurity$outboundSchema.parse(probeRemoteMcpURLSecurity),
  );
}

/** @internal */
export type ProbeRemoteMcpURLRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ProbeURLForm: ProbeURLForm$Outbound;
};

/** @internal */
export const ProbeRemoteMcpURLRequest$outboundSchema: z.ZodMiniType<
  ProbeRemoteMcpURLRequest$Outbound,
  ProbeRemoteMcpURLRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    probeURLForm: ProbeURLForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      probeURLForm: "ProbeURLForm",
    });
  }),
);

export function probeRemoteMcpURLRequestToJSON(
  probeRemoteMcpURLRequest: ProbeRemoteMcpURLRequest,
): string {
  return JSON.stringify(
    ProbeRemoteMcpURLRequest$outboundSchema.parse(probeRemoteMcpURLRequest),
  );
}
